export default "__VITE_ASSET__fbc10f9c__"